/**
 * UserTableEmpty - Empty state component for user table.
 *
 * Displays an empty state message in a Card wrapper.
 */

import { Card, CardHeader, CardTitle, CardContent } from '@lean-agility/design-system/react';

export interface UserTableEmptyProps {
  /**
   * Title to display in the card header.
   */
  title: string;
}

export function UserTableEmpty({ title }: UserTableEmptyProps) {
  return (
    <Card className="min-w-150">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div
          className="
            p-12 text-center text-text-muted
            dark:text-text-muted
          "
        >
          <p>No users found.</p>
        </div>
      </CardContent>
    </Card>
  );
}
